import { CreateOverdueReportReduxState, OverdueReportReducerDispatch, OverdueReportReduxTypes } from "./types"

const CREATE_NPA_REPORT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateOverdueReportReducer = (state: CreateOverdueReportReduxState = CREATE_NPA_REPORT_INIT_STATE, action: OverdueReportReducerDispatch) => {
    switch (action.type) {
        case OverdueReportReduxTypes.OVERDUE_REPORT: {
            return {
                ...state,
                loading: true
            }

        }
        case OverdueReportReduxTypes.OVERDUE_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case OverdueReportReduxTypes.OVERDUE_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return { ...state };
    }
}

export { CreateOverdueReportReducer }